import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Params, Router } from '@angular/router';

import { SnApplianceCapacityStatus } from '@lib/api/entities';

@Component({
  selector: 'fs-appliance-capacity-status',
  templateUrl: './appliance-capacity-status.component.html',
  styleUrls: ['./appliance-capacity-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplianceCapacityStatusComponent {
  @Input()
  public readonly capacityStatus: SnApplianceCapacityStatus;

  @Input()
  public readonly applianceId: string;

  public readonly APPLIANCE_CAPACITY_STATUS = SnApplianceCapacityStatus;

  constructor(private readonly router: Router) {}

  public resolveCapacityStatus(): void {
    const queryParams: Params = { appliance: this.applianceId };
    this.router.navigate(['/appliances/list/appliance'], { queryParams });
  }
}
